if ($('[data-bs-toggle="popover"]').length) {
    // Evaluates if there is any tooltip on dom
    var popoverTriggerList = [].slice.call(
        document.querySelectorAll('[data-bs-toggle="popover"]')
    );
    var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new Popover(popoverTriggerEl, {
            delay: { show: 200, hide: 100 },
            boundary: "viewport",
        });
    });
}

if ($('[data-bs-toggle="popover_office"]').length) {
    // Evaluates if there is any tooltip on dom
    var popoverTriggerList = [].slice.call(
        document.querySelectorAll('[data-bs-toggle="popover_office"]')
    );
    var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new Popover(popoverTriggerEl, {
            delay: { show: 200, hide: 100 },
            customClass: "officeErrorInputTooltip",
        });
    });
}

window.tooltipOffices = (id) => {
    let elementInput = $(`#${id}`)[0];
    let popOverElement = new Popover(elementInput, {
        delay: { show: 200, hide: 100 },
        customClass: "officeErrorInputTooltip",
    });

    popOverElement.show();
    setTimeout(() => {
        popOverElement.hide();
    }, 5000);
};
